import { useEffect, useState } from 'react'
import { Snackbar, Alert } from '@mui/material'
import { ERROR_MESSAGE_OFFLINE } from '../constants/errorMessages'
import { useOnlineStatus } from '../hooks/useOnlineStatus'

/**
 * Global banner shown whenever the browser reports it is offline.
 *
 * Follows the same convention as <UpdateNotification>: a persistent condition
 * surfaced as a dismissable, app-wide MUI Snackbar (not a transient toast).
 * Dismissing it only suppresses the current offline episode; if the browser
 * goes back online and later drops offline again, the banner reappears.
 */
export function OfflineNotification() {
  const isOnline = useOnlineStatus()
  const [dismissed, setDismissed] = useState(false)

  // Reset the dismissed state once connectivity returns so a future offline
  // episode shows the banner again.
  useEffect(() => {
    if (isOnline) {
      setDismissed(false)
    }
  }, [isOnline])

  return (
    <Snackbar
      open={!isOnline && !dismissed}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        marginTop: 2,
        '& .MuiAlert-root': {
          width: '100%',
        },
      }}
    >
      <Alert
        severity="warning"
        variant="filled"
        id="offline-notification-alert"
        onClose={() => setDismissed(true)}
        sx={{
          fontSize: '0.95rem',
          alignItems: 'center',
        }}
      >
        {ERROR_MESSAGE_OFFLINE}
      </Alert>
    </Snackbar>
  )
}
